<template>
  <div class="bodys">
    <div class="head">{{ lang.AITrading }}</div>
    <div class="contentss">
      <div class="userInfo">
        <div class="market-mobile"></div>
        <div class="market-mobile2"></div>
        <div class="new-feature" style="margin-bottom: 20px">
          <div class="title">
            <i class="el-icon-s-finance" style="font-size: 20px;font-weight: 600" ></i>
            {{ lang.aiCoin }}
          </div>
          <div class="coin" v-if="userInfo.aiAmt == 0 ">$ 0.000</div>
          <div class="coin" v-else>$ {{ userInfo.aiAmt }}</div>

          <div class="infos">
            <div class="info">
              <div class="info-title">{{lang.todayBenefit}}</div>
              <div class="info-content" v-if="userInfo.invtToday == 0 ">$ 0.00</div>
              <div class="info-content" v-else>$ {{ userInfo.invtToday }}</div>
            </div>
            <div class="info">
              <div class="info-title">{{lang.totalEarnings}}</div>
              <div class="info-content" v-if="userInfo.invtSum == 0 ">$ 0.00</div>
              <div class="info-content" v-else>$ {{ userInfo.invtSum }}</div>
            </div>
            <div class="info">
              <div class="info-title">{{ lang.hbl }}</div>
              <div class="info-content">{{ userInfo.aiHbl }}%</div>
            </div>
          </div>
          <div class="big-buttons">
            <div class="button">
              <div class="button-icon">
                <img src="../assets/images/strategy_icon1.svg" alt="">
              </div>
              <div class="button-name">{{ lang.FinancialSecurity }}</div>
            </div>
            <div class="button">
              <div class="button-icon">
                <img src="../assets/images/strategy_icon2.svg" alt="">
              </div>
              <div class="button-name">{{ lang.StableIncome }}</div>
            </div>
            <div class="button">
              <div class="button-icon">
                <img src="../assets/images/strategy_icon3.svg" alt="">
              </div>
              <div class="button-name">{{ lang.Easyuse }}</div>
            </div>

          </div>
          <div class="explain">
            <span>{{ lang.tip21 }}</span>
          </div>
        </div>
      </div>
      <div class="new-feature">
        <div class="title">{{lang.Create}}</div>
        <div class="input-list" @click.stop>
          <div class="input">
            <div class="lable">{{ lang.TheTerm }}</div>
            <el-select v-model="aiRatioId" @change="selectAI" >
              <el-option :label="item.name" :value="item.id" v-for="item in aiRatioInfo">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.minRatio }} ～ {{item.maxRatio}} %</span>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="input-list">
          <div class="input" style="position: relative">
            <div class="lable">{{ lang.amount }}</div>
            <div style="position: relative">
              <el-input v-model="amt" placeholder="0"></el-input>
              <div class="max" @click="amt = userInfo.blc">{{lang.max}}</div>
            </div>

          </div>
        </div>
        <div class="infos">
          <div class="info">
            <div class="title" style="color: hsla(0, 0%, 100%, .3);">ROR</div>
            <div>{{activatItem.minRatio}}~{{ activatItem.maxRatio }}%</div>
          </div>
          <div class="info">
            <div class="title" style="color: hsla(0, 0%, 100%, .3);">{{lang.Limit}}</div>
            <div>{{activatItem.minAmt}}~{{ activatItem.maxAmt }}</div>
          </div>
        </div>
        <div class="button" @click="addAiOrder">
          <el-button type="danger" round>{{ lang.confirm }}</el-button>
        </div>
      </div>
    </div>
    <Bottom />
    <div class="tc" v-if="centerDialogVisible">
      <div class="tc-head">
        <img src="../assets/images/trading.svg" width="30">
        <span>{{lang.confirmOrder}}</span>
        <span>{{lang.ailhcg}}</span>
      </div>
      <div class="tc-body">
        <div class="tc-line">
          <div class="tc-left">{{ lang.amount }}</div>
          <div class="tc-right">${{amt2}}</div>
        </div>
        <div class="tc-line">
          <div class="tc-left">{{ lang.TheTerm }}</div>
          <div class="tc-right">{{activatItem.name}}</div>
        </div>
        <div class="tc-line">
          <div class="tc-left">ROR</div>
          <div class="tc-right">{{activatItem.minRatio}}~{{ activatItem.maxRatio }}%</div>
        </div>
      </div>
      <div class="button" @click="centerDialogVisible = false">
        <el-button type="danger" round>{{ lang.confirm }}</el-button>
      </div>


    </div>
    <div class="zzc" v-if="centerDialogVisible"></div>
  </div>
</template>
<script type="text/javascript">
  import {
    mapState
  } from 'vuex';
  import axios from 'axios'
  import router from "../router";
  import store from "../store";
  import {ref} from "vue";
  export default {
    data() {
      return {
        centerDialogVisible:ref(false),
        input:'',
        xregion:'',
        amt:"",
        amt2:0,
        aiRatioId:'',
        userInfo :{
          "blc":0,
        },
        aiRatioInfo :{},
        activatItem :{},
      }
    },
    watch:{
      amt(newV,oldV){
        var isOk = false
        for (var i in this.aiRatioInfo){
          if (newV >=this.aiRatioInfo[i].minAmt && newV <=this.aiRatioInfo[i].maxAmt){
              this.aiRatioId = this.aiRatioInfo[i].id
              this.activatItem = this.aiRatioInfo[i]
              isOk = true
              break
          }
        }
        if(!isOk){
          this.aiRatioId = this.aiRatioInfo[0].id
          this.activatItem = this.aiRatioInfo[0]
        }
      }
    },
    computed: {
      ...mapState(['lang']),
    },
    mounted() {
      this.getAiRatio()
    },
    created() {
      this.getUserInfo()
    },
    methods: {
      selectAI(id){
        for (var i in this.aiRatioInfo){
          if (this.aiRatioInfo[i].id == id){
            this.activatItem = this.aiRatioInfo[i]
            this.aiRatioId =this.aiRatioInfo[i].id
            break
          }
        }
      },
      getUserInfo(){
        this.$xhrGet('/member/center').then(res => {
          if (res.err == 0) {
            this.userInfo = res.data
          }
        })
      },
      getAiRatio(){
        this.$xhrGet('/product/aiRatio').then(res => {
          if (res.err == 0) {
            this.aiRatioInfo = res.data
            for (var i in this.aiRatioInfo){
              this.activatItem = this.aiRatioInfo[i]
              this.aiRatioId =this.aiRatioInfo[i].id
              break
            }
          }
        })
      },
      addAiOrder() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest("post", "/product/aiOrder", {amt: this.amt,aiRatioId: this.aiRatioId}).then((res) => {
          this.$indicator.close();
          this.amt2 = this.amt;
          this.amt = 0;
          if (res.data.err == 0) {
            this.centerDialogVisible = true
            this.getUserInfo()
            this.$message({message: "",  type: 'success'});
          }else{
            this.$message({message: res.data.msg,  type: 'error'});
          }
        })
      },
    }
  }
</script>
<style>
.zzc{
  height: 100%;
  background-color: rgba(0, 0, 0, .7);
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
.tc{
  padding: 0 20px  40px 20px;
  z-index: 1001;
  width: 90%;
  background: #1a1a1a;
  position: fixed;
  top: 45%;
  left: 50%;
  overflow: hidden;
  font-size: 0.42667rem;
  border-radius: 0.42667rem;
  transform: translate3d(-50%, -50%, 0);
  backface-visibility: hidden;
  transition: .3s;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
}
.tc .tc-head{
  padding:30px 0;
  border-bottom: 1px #2c2c2c solid;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.tc .tc-head img{
  margin-bottom: 10px;
}

.tc .tc-body{
  padding-top: 20px;
}
.tc .tc-body .tc-line{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.tc .tc-body .tc-line .tc-left{
  opacity: .7;
}
.bodys{
  height: 100%;
  background: #000;
  color: #fff;
}
.head{
  padding: 15px 15px 0 ;
  font-size: 20px;
  font-weight: 600;
}
.contentss{
  padding: 0.4rem;
  height: 87%;
  background: #000;
  width: 100%;
  margin: auto;
  overflow: auto;
  position: relative;
}
.contentss .userInfo{
  overflow: hidden;
  position: relative;
}
.market-mobile {
  background: #d8d8d8;
  mix-blend-mode: normal;
  opacity: .08;
  transform: rotate(326deg);
  width: 130px;
  height: 236px;
  position: absolute;
  right: -30px;
  top: -100px;
  margin-top: 50px;
}
.market-mobile2 {
  background: #d8d8d8;
  mix-blend-mode: normal;
  opacity: .08;
  transform: rotate(326deg);
  width: 130px;
  height: 236px;
  position: absolute;
  right: -70px;
  top: -100px;
  margin-top: 50px;
}
.new-feature{
  padding: 15px;
  background: #1a1a1a;
  border-radius: 20px;
}
.new-feature .title{
  font-size: 12px;
}
.new-feature .coin{
  font-size: 32px;
  font-weight: 600;
  padding: 10px 0px;
  border-bottom: 1px solid hsla(0, 0%, 100%, .07);
}
.infos{
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.infos .info-title{
  font-weight: 500;
  font-size: 14px;
  color: #fff;
  opacity: .3;
}
.infos .info-content{
  font-weight: 700;
  font-size: 16px;
  font-family: DIN Alternate;
  margin-top: 8px;
}
.big-buttons{
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.big-buttons .button {
  flex: 0 0 30%;
  background: hsla(0, 0%, 100%, .07);
  border-radius: 0.42667rem;
  padding: 15px 10px;
}
.big-buttons .button .button-name{
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
}
.explain {
  font-size:12px;
  color: hsla(0, 0%, 100%, .5);
}
.input-list{
  margin-top:25px;
}
.input-list .lable {
  font-weight: 500;
  font-size: 12px;
  color: hsla(0, 0%, 100%, .3);
  margin-bottom: 10px;
}
.button{
  margin: 10px 0;
}
.el-input__inner {
  background-color: #d8d8d814;
  border:0px;
  color: #fff;
}
.el-select-dropdown {
  background-color: #d8d8d814;
  z-index: 1050 !important;

}
.el-select-dropdown__item {
  color: #ffff;
}
.el-select {
  width: 100%;
}
.el-button.is-round {
  border-radius: 13px;
  width: 100%;
}
.el-button--danger,.el-button--danger:focus, .el-button--danger:hover {
  color: #000;
  background: #c0dd2b;

  border-color:#c0dd2b;
}
.el-select-dropdown__item.selected {
  color: #409EFF;
  font-weight: 700;
}

 .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
   background-color: #d8d8d814;
 }
 .el-select-dropdown {
   background-color: #1a1a1a;
 }
 .max{
   background: #1a1a1a;
   position: absolute;
   top: 2px;
   padding: 10px 20px;
   right: 3px;
   border-radius:10px;
 }



</style>